import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const client = axios.create({ baseURL: API, withCredentials: true });

export const setToken = (token, refresh) => {
  if (token) localStorage.setItem("token", token);
  else localStorage.removeItem("token");
  if (refresh) localStorage.setItem("refresh_token", refresh);
  if (token === null && refresh === undefined) localStorage.removeItem("refresh_token");
};

client.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  // حقن نطاق فرع المحاسبة تلقائياً لكل استدعاء إلى /accounting بدون تكرار في كل صفحة.
  const url = config.url || "";
  if (url.includes("/accounting/") || url.startsWith("/accounting")) {
    const bid = localStorage.getItem("acct.branchId") || "";
    if (bid) {
      const params = { ...(config.params || {}) };
      if (params.branch_id == null || params.branch_id === "") params.branch_id = bid;
      config.params = params;
    }
  }
  return config;
});

let refreshing = null;

// Only a real 401/403 from the server means the session is gone.
// Network glitches (offline, cold PWA start) must NEVER wipe the stored tokens.
const isDefinitive = (error) => [401, 403].includes(error?.response?.status) || error?.definitive;

const renew = async () => {
  const refresh = localStorage.getItem("refresh_token");
  if (!refresh) {
    const missing = new Error("no_refresh_token");
    missing.definitive = true;
    throw missing;
  }
  const { data } = await axios.post(
    `${API}/auth/refresh`,
    {},
    { withCredentials: true, headers: { "X-Refresh-Token": refresh } }
  );
  setToken(data.access_token, data.refresh_token);
  return data.access_token;
};

client.interceptors.response.use(
  (response) => response,
  async (error) => {
    const { config, response } = error;
    const isAuthCall = config?.url?.includes("/auth/refresh") || config?.url?.includes("/auth/login");
    if (response?.status !== 401 || config?._retried || isAuthCall) throw error;
    config._retried = true;
    try {
      refreshing = refreshing || renew();
      const token = await refreshing;
      refreshing = null;
      config.headers.Authorization = `Bearer ${token}`;
      return client(config);
    } catch (refreshError) {
      refreshing = null;
      if (isDefinitive(refreshError)) setToken(null);
      throw error;
    }
  }
);

export const errorCode = (error) => {
  const detail = error?.response?.data?.detail;
  if (detail && typeof detail === "object" && !Array.isArray(detail)) return detail;
  if (typeof detail === "string") return { code: detail };
  if (Array.isArray(detail)) return { code: "generic", msg: detail.map((d) => d.msg).join(", ") };
  return { code: "generic" };
};

export default client;
